require('./bootstrap')

document.querySelectorAll(".picker").forEach(picker => { 
    picker.addEventListener("click", (event) => {
        event.preventDefault();

        document.querySelectorAll('#' + picker.dataset.pickercontainer + ' .picker').forEach(el => {
            el.classList.remove('active');
        })

        document.querySelectorAll('#' + picker.dataset.textcontainer + ' span').forEach(el => {
            el.classList.add('d-none');
        })

        document.getElementById(picker.dataset.targetid).src = picker.dataset.img;

        document.getElementById(picker.dataset.textid).classList.remove('d-none');
        
        picker.classList.add('active');
        
    })
});